import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { CheckCircle2, XCircle, Send, AlertTriangle } from "lucide-react";
import { NeuButton } from "../../components/neu/Neu";
import { sourceRelease, destinationConfirm, rejectTransfer } from "../../api/warehouse";
import { SignDialog } from "./SignDialog";

// أزرار المناقلة: كل إجراء (إرسال/مطابقة/رفض) يفتح حوار توقيع بالإصبع.
export const TransferActions = ({ row, onDone }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [dlg, setDlg] = useState(null); // {action, title, hue, keeperName, hint}
  const [busy, setBusy] = useState(false);

  const openRelease = () => setDlg({ action: "release", title: t("warehouse.tr.signRelease"),
    hue: "from-sky-500 to-sky-600", keeperName: row.from_wh?.keeper_name,
    hint: t("warehouse.tr.signReleaseHint") });
  const openMatch = () => setDlg({ action: "match", title: t("warehouse.tr.signMatch"),
    hue: "from-emerald-500 to-emerald-600", keeperName: row.to_wh?.keeper_name,
    hint: t("warehouse.tr.signMatchHint") });

  const onConfirm = async ({ signature, note }) => {
    setBusy(true);
    try {
      if (dlg.action === "release") await sourceRelease(row.transfer_id, note, signature);
      else if (dlg.action === "match") await destinationConfirm(row.transfer_id, "match", note, [], signature);
      toast.success(t("warehouse.tr.signed")); setDlg(null); onDone();
    } catch (e) { toast.error(e?.response?.data?.detail?.code || t("errors.generic")); }
    finally { setBusy(false); }
  };

  const doReject = async () => {
    const r = window.prompt(t("warehouse.tr.rejectReason"));
    if (!r) return;
    try { await rejectTransfer(row.transfer_id, r); toast.success(t("warehouse.tr.rejected")); onDone(); }
    catch (e) { toast.error(e?.response?.data?.detail?.code || t("errors.generic")); }
  };

  return (<>
    <div className="flex flex-wrap justify-end gap-1">
      {row.state === "pending_source" && (<>
        <NeuButton className="bg-sky-500 px-2 py-1 text-[10px] text-white hover:bg-sky-600"
                   data-testid={`trf-release-${row.transfer_id}`} onClick={openRelease}>
          <Send className="inline h-3 w-3" /> {t("warehouse.tr.release")}</NeuButton>
        <NeuButton className="px-2 py-1 text-[10px]"
                   data-testid={`trf-reject-${row.transfer_id}`} onClick={doReject}>
          <XCircle className="inline h-3 w-3 text-rose-600" /></NeuButton>
      </>)}
      {row.state === "in_transit" && (<>
        <NeuButton className="bg-emerald-500 px-2 py-1 text-[10px] text-white hover:bg-emerald-600"
                   data-testid={`trf-match-${row.transfer_id}`} onClick={openMatch}>
          <CheckCircle2 className="inline h-3 w-3" /> {t("warehouse.tr.match")}</NeuButton>
        <NeuButton className="bg-amber-500 px-2 py-1 text-[10px] text-white hover:bg-amber-600"
                   data-testid={`trf-shortage-${row.transfer_id}`}
                   onClick={() => navigate(`/warehouse/transfers/${row.transfer_id}/receive`)}>
          <AlertTriangle className="inline h-3 w-3" /> {t("warehouse.tr.shortage")}</NeuButton>
        <NeuButton className="px-2 py-1 text-[10px]"
                   data-testid={`trf-reject-${row.transfer_id}`} onClick={doReject}>
          <XCircle className="inline h-3 w-3 text-rose-600" /></NeuButton>
      </>)}
    </div>
    {dlg && <SignDialog {...dlg} busy={busy} onCancel={() => setDlg(null)} onConfirm={onConfirm} />}
  </>);
};
